import { Form, FormField, PrimaryButton } from "common/Forms";
import { SelectInput, TextInput } from "common/Forms/inputs";
import { Grid, GridCell } from "common/Grid/Grid";
import { ScreenSizes, useScreenSizes } from "common/Grid/useScreenSize";
import { staffRoleOptions } from "Constant/Constant";

const statusOptions = [
  { label: "Active", value: "true" },
  { label: "Inactive", value: "false" },
];

export const AdvancedSearchForm = ({ filters, setFilters, siteIdOptions, onApply, onClear }) => {
  const screenSize = useScreenSizes();
  const columns = screenSize === ScreenSizes.Large ? 4 : screenSize === ScreenSizes.Medium ? 2 : 1;

  return (
    <Form>
      <Grid columns={columns} classNames={["!gap-x-3 !gap-y-5"]}>
        <GridCell>
          <FormField
            id="search"
            label="Search"
            classNames={["text_input_box"]}
            inputFactory={(id, name) => (
              <TextInput
                id={id}
                name={name}
                placeholder="Search by name, username, email..."
                value={filters.search}
                onChange={(_, val) => setFilters((prev) => ({ ...prev, search: val }))}
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterRole"
            label="Role"
            inputFactory={(id, name) => (
              <SelectInput
                id={id}
                name={name}
                placeholder="Select role"
                selectedKey={filters.role}
                optionProvider={() => staffRoleOptions}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                isClearable={true}
                onChange={(_, n) =>
                  setFilters((prev) => ({ ...prev, role: n ? n.value : "" }))
                }
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterStatus"
            label="Status"
            inputFactory={(id, name) => (
              <SelectInput
                id={id}
                name={name}
                placeholder="Select status"
                selectedKey={filters.isActive}
                optionProvider={() => statusOptions}
                keySelector={(x) => x.value}
                labelSelector={(x) => x.label}
                isClearable={true}
                onChange={(_, n) =>
                  setFilters((prev) => ({ ...prev, isActive: n ? n.value : "" }))
                }
              />
            )}
          />
        </GridCell>

        <GridCell>
          <FormField
            id="filterSiteid"
            label="Site ID"
            inputFactory={(id, name) => (
              <SelectInput
                id={id}
                name={name}
                placeholder="Select site id"
                selectedKey={filters.siteid}
                optionProvider={() => siteIdOptions}
                keySelector={(x) => `${x.value}`}
                labelSelector={(x) => `${x.label}`}
                isClearable={true}
                onChange={(_, n) =>
                  setFilters((prev) => ({ ...prev, siteid: n ? `${n.value}` : "" }))
                }
              />
            )}
          />
        </GridCell>

        <GridCell column={columns} vertical="bottom">
          <Grid columns={2} columnGap={1}>
            <GridCell>
              <PrimaryButton action={onApply} isWide={true} classNames={["justify-center"]}>
                Apply Filters
              </PrimaryButton>
            </GridCell>
            <GridCell>
              <PrimaryButton action={onClear} isWide={true} classNames={["justify-center"]}>
                Clear Filters
              </PrimaryButton>
            </GridCell>
          </Grid>
        </GridCell>
      </Grid>
    </Form>
  );
};
